//import firebase from 'firebase/compat/app';
import { initializeApp } from "firebase/app";
import { collection,getFirestore } from "firebase/firestore";
import { getMessaging, getToken, onMessage } from 'firebase/messaging'
//import 'firebase/compat/storage';
//import 'firebase/compat/firestore';
//import 'firebase/compat/auth';
//import "firebase/compat/database";

import { FirebaseConfig } from "../config/keys";
const firebaseApp = initializeApp(FirebaseConfig);
const messaging = getMessaging(firebaseApp);
const settings = {  };
export const dbFirestore = getFirestore(firebaseApp);



//const settings = {timestampsInSnapshots: true};
//const databaseRef = firebase.database().ref();
//dbFirestore.settings(settings);

export const reservasRef = collection(dbFirestore,"reservas");
/*
export const sesionesRef = dbFirestore.collection("sesiones");
export const usuarios_online = firebase.database().ref("/usuarios_online");
export const refStorageImg = firebase.storage().ref('/imgs');
export const authRef = firebase.auth();
export const deposito = firebase.storage()
*/

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      resolve(payload);
    });
});

export const Sendrequest = () => {
    console.log("Requesting User Permission......");
    try {
        Notification.requestPermission().then((permission) => {
      if (permission === "granted") {
        console.log("Notification User Permission Granted.");
  
        return getToken(messaging, { vapidKey: process.env.REACT_APP_FIREBASE_MSGKEY })
          .then((currentToken) => {
            if (currentToken) {
              console.log('Client Token: ', currentToken);
              
            } else {
              
              console.log('Failed to generate the registration token.');
            }
          })
          .catch((err) => {
            console.log('An error occurred when requesting to receive the token.', err);
          });
      } else {
        console.log("User Permission Denied.");
      }
    });  
    } catch (error) {
      console.log(error)
    }

  }